/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { Button } from '@styles/button.style'
import { MatchRecordIco } from '@shared/Icon/MatchupIcon'
import DialogUtils from '@utils/dialog-utils'
import { observer } from 'mobx-react'
import { MatchRecordSimpleMatchInfo } from '@views/MatchRecord'
import useRootStore from '@store/useRootStore'
import { PAGE_TYPE } from '@interface/common'

interface Props {
  pageType: PAGE_TYPE
  matchRecordSimpleMatchInfo: MatchRecordSimpleMatchInfo
}

export const MatchRecordButton: React.FC<Props> = observer((props: Props) => {
  const { logStore } = useRootStore()
  const { pageType, matchRecordSimpleMatchInfo } = props

  const onClickMatchRecord = () => {
    if (pageType === PAGE_TYPE.MATCHUP && matchRecordSimpleMatchInfo.isLiveMatch) {
      logStore.writeButtonLog({ pageId: 'b020', buttonId: '006' }).catch(console.error)
    } else if (pageType === PAGE_TYPE.MATCHUP_RESULT) {
      logStore.writeButtonLog({ pageId: 'b030', buttonId: '003' }).catch(console.error)
    }
    DialogUtils.showMatchRecord(matchRecordSimpleMatchInfo)
  }

  return (
    <Button className="odds-block-list--btn sub-btn match-record-btn" onClick={onClickMatchRecord}>
      <span className="btn-bg"/>
      <MatchRecordIco/>
    </Button>
  )
})
